import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentFreeText from './CustomPageDetailContentFreeText';
import CustomPageDetailContentCarousel from './CustomPageDetailContentCarousel';
import CustomPageDetailContentNews from './CustomPageDetailContentNews';
import CustomPageDetailContentCatalogMiddleLayout from './CustomPageDetailContentCatalogMiddleLayout';
import CustomPageDetailContentCatalogLargeLayout from './CustomPageDetailContentCatalogLargeLayout';
import CustomPageDetailContentEcMiddleLayout from './CustomPageDetailContentEcMiddleLayout';
import CustomPageDetailContentEcLargeLayout from './CustomPageDetailContentEcLargeLayout';
import CustomPageDetailContentManufacturerMiddleLayout from './CustomPageDetailContentManufacturerMiddleLayout';
import CustomPageDetailContentManufacturerLargeLayout from './CustomPageDetailContentManufacturerLargeLayout';
import CustomPageDetailContentSurveyBasicLayout from './CustomPageDetailContentSurveyBasicLayout';
import CustomPageDetailContentForm from './CustomPageDetailContentForm';
import gql from 'graphql-tag';

// DEPENDENCY import https://static.aperza.com/common/js/slick.min.js
// TODO: Convert the slick to the ported react version
// TODO: Convert matchheight to the ported react version
const CustomPageDetailContent = (props) => {

  let {
    companyContractDisplayId,
    pageBlocks,
  } = props;

  //let [sliderInitializerRef] = useState(() => {});
  const sliderInitializerRef = () => {
  };

  //initializeSlider = () => {
  // function readmore(){
  //   if($('.js_readmore').length){
  //     $('.js_readmore').each(function(){
  //       var moreLink = $(this).data('more');
  //       var lessLink = $(this).data('less');
  //       var collapseHeight = ($(this).data('height')!='')?$(this).data('height'):0;
  //       $(this).find('.js_readmoreTarget').readmore({
  //         speed: 300,
  //         collapsedHeight: collapseHeight,
  //         moreLink: '<a class="accBtn" href="#">' + moreLink + '</a>',
  //         lessLink: '<a class="accBtn" href="#">' + lessLink + '</a>'
  //       });
  //     })
  //   }
  // }
  //
  // // initialize the slider for the catalog image navigation, after rendering the components
  // // import https://static.aperza.com/common/js/slick.min.js
  // function slider(){
  //   if($('.js_slider').length){
  //     $('.js_slider ul').each(function(){
  //       var $slickElement = $(this);
  //       let documentTotalPageNumber = $(this).data('document-total-page-number');
  //       var $status = $slickElement.siblings('.slidePaging').find('span');
  //       $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //         var i = (currentSlide ? currentSlide : 0) + 1;
  //         $status.text(i + '/' + (documentTotalPageNumber ? documentTotalPageNumber : slick.slideCount));
  //       });
  //       $slickElement.not('.slick-initialized').slick({
  //         'prevArrow':'<button type=button class=slick-prev>&#xf104;</button>',
  //         'nextArrow':'<button type=button class=slick-next>&#xf105;</button>',
  //         'infinite':false
  //       });
  //     });
  //     $('.modal').on('shown.bs.modal', function (event) {
  //       var clickBotton = $(event.relatedTarget).data('clickbotton');
  //       $(this).find('.js_slider ul').slick('setPosition');
  //       readmore();
  //     });
  //   }
  // }
  //
  // // initialize the slider for the catalog image navigation, after rendering the components
  // slider();
  //
  // // initialize matchHeight
  // $.fn.matchHeight._applyDataApi();
  //}

  // componentDidMount() {
  //   this.initializeSlider();
  // }

  const pageBlockContents = () => {
    
    let revPageBlocks = pageBlocks;
    // Check if first PageBlock is CAROUSEL_SLIDER filter out
    if(revPageBlocks[0].pageBlockLayoutType.pageBlockLayoutTypeCode == 'CAROUSEL_SLIDER_LAYOUT') {
      revPageBlocks = revPageBlocks.filter((revPageBlock, index) => index != 0);
    } else {
      // Look for any CAROUSEL_SLIDER, SHIFT them to the last
      let filterOutCarousel = revPageBlocks.filter((revPageBlock, key) => revPageBlock.pageBlockLayoutType.pageBlockLayoutTypeCode != 'CAROUSEL_SLIDER_LAYOUT');
      let gettingCarousel = revPageBlocks.filter((revPageBlock, key) => revPageBlock.pageBlockLayoutType.pageBlockLayoutTypeCode == 'CAROUSEL_SLIDER_LAYOUT');
      revPageBlocks = [...filterOutCarousel, ...gettingCarousel];
    }
    
    return revPageBlocks.map((pageBlock) => {
      console.log('PAGE BLOCK TYPE IS: ', pageBlock.pageBlockLayoutType.pageBlockLayoutTypeCode);

      switch (pageBlock.pageBlockLayoutType.pageBlockLayoutTypeCode) {
        case 'FREETEXT_BASIC_LAYOUT':
          return <CustomPageDetailContentFreeText pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;
        case 'CAROUSEL_SLIDER_LAYOUT':
          return <CustomPageDetailContentCarousel pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;
        case 'CONTENT_NEWS_LIST_FULL_LAYOUT':
        case 'CONTENT_NEWS_LIST_BASIC_LAYOUT':
          return <CustomPageDetailContentNews pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;
        //
        // // Delegate mini,small layouts to -> Middle layout
        case 'CATALOG_MINIMAL_LAYOUT':
        case 'CATALOG_SMALL_LAYOUT':
        case 'CATALOG_MIDDLE_LAYOUT':
          return <CustomPageDetailContentCatalogMiddleLayout companyContractDisplayId={companyContractDisplayId}
                                                             pageBlock={pageBlock} key={pageBlock.pageBlockId}
                                                             sliderInitializerRef={sliderInitializerRef}/>;
        case 'CATALOG_LARGE_LAYOUT':
          return <CustomPageDetailContentCatalogLargeLayout companyContractDisplayId={companyContractDisplayId}
                                                            pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;

        case 'PRODUCT_MINIMAL_LAYOUT':
        case 'PRODUCT_SMALL_LAYOUT':
        case 'PRODUCT_MIDDLE_LAYOUT':
          return <CustomPageDetailContentManufacturerMiddleLayout pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;
        case 'PRODUCT_LARGE_LAYOUT':
          return <CustomPageDetailContentManufacturerLargeLayout pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;

        case 'ITEM_MINIMAL_LAYOUT':
        case 'ITEM_SMALL_LAYOUT':
        case 'ITEM_MIDDLE_LAYOUT':
          return <CustomPageDetailContentEcMiddleLayout pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;
        case 'ITEM_LARGE_LAYOUT':
          return <CustomPageDetailContentEcLargeLayout pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;

        case 'SURVEY_BASIC_LAYOUT':
          // return <CustomPageDetailContentSurveyBasicLayout pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;

        case 'FORMS_BASIC_LAYOUT':
          return <CustomPageDetailContentForm pageBlock={pageBlock} key={pageBlock.pageBlockId}/>;

        default:
          return 'Unhandled Layout:' + pageBlock.pageBlockLayoutType.pageBlockLayoutTypeCode;
      }
    });
  };

  return (
    <>
      {pageBlockContents()}
    </>
  );
};

CustomPageDetailContent.fragments = {
  pageBlocks: gql`
      fragment CustomPageDetailContent_pageBlocks on CustomPageBlockCacheResponseSchemaType {
          pageBlockId
          pageBlockTypeId
          pageBlockTypeCode
          pageBlockTitle
          pageBlockDescriptionHtml
          pageBlockDescriptionMarkdown
          pageBlockLayoutType {
              pageBlockLayoutTypeCode
              pageBlockItemsPerLinePcViewCount
              pageBlockItemsPerLineSpViewCount
          }
          pageBlockItems {
              pageBlockItemId
              itemId
              itemOpenLinkType
              itemName
              itemDescription
              itemImageUrl
              itemUrl
              itemCategoryName
              displayOrder
              extendProperties {
                  cluezCatalogId
                  cluezCompanyId
                  documentSizeBytes
                  documentSubName
                  documentTotalPageNumber
                  itemBuyUrl
                  itemDiscounted
                  itemDiscountedOriginalPrice
                  itemDiscountedRatePercentage
                  itemPrice
                  numberOfStocks
                  openPrice
                  productSku
                  salesMethodLabel
                  salesMethodMaker
                  shippingDate
                  shopName
                  shopUrl
                  itemCompanyUrl
                  itemCompanyName
                  itemCompanyLogoUrl
                  itemBrandName
                  itemPreviewImageUrls
                  publishDatetime
                  contentTags {
                      contentTagName
                      contentTagClass
                  }
              }
          }
          forms {
              ...CustomPageDetailContentForm_forms
          }
      }
    ${CustomPageDetailContentForm.fragments.forms}
  `,
};

CustomPageDetailContent.propTypes = {
  companyContractDisplayId: PropTypes.number.isRequired,
  pageBlocks: PropTypes.any.isRequired,
};

export default CustomPageDetailContent;
